//// filepath: c:\Users\Jesús del Moral\web-ayuntamiento\frontend\src\Components\Navbar.js
import React, { useState } from 'react';
import { Navbar as BootstrapNavbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Navbar.css';
import { FaBars, FaInstagram, FaWhatsapp, FaYoutube, FaRobot } from 'react-icons/fa';
import escudo from '../Images/Escudo.png';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const location = useLocation();
  const [showAyuntamiento, setShowAyuntamiento] = useState(false);
  const [showPueblo, setShowPueblo] = useState(false);
  const [showServicios, setShowServicios] = useState(false);
  const [showEconomia, setShowEconomia] = useState(false);
  const [expanded, setExpanded] = useState(false);

  // Función para cerrar el menú móvil
  const closeNavbar = () => {
    setExpanded(false);
  };

  const links = [
    {
      id: 1,
      label: 'Ayuntamiento',
      dropdownItems: [
        { link: '/ayuntamiento/saludo-alcalde', label: 'Saludo del Alcalde' },
        { link: '/ayuntamiento/corporacion-municipal', label: 'Corporación Municipal' },
        { link: '/ayuntamiento/organos-gobierno', label: 'Órganos de Gobierno' },
        { link: '/ayuntamiento/plenos-video', label: 'Plenos en Video' },
        { link: '/ayuntamiento/actas-pleno', label: 'Actas de Pleno' },
        { link: '/ayuntamiento/ordenanzas', label: 'Ordenanzas' },
      ],
    },
    {
      id: 5,
      label: 'El Pueblo',
      dropdownItems: [
        { link: '/pueblo/datos-interes', label: 'Datos de Interés' },
        { link: '/pueblo/fiestas', label: 'Fiestas' },
        { link: '/pueblo/lugares-historicos', label: 'Lugares Históricos' },
        { link: '/pueblo/fotos', label: 'Fotos' },
        { link: '/pueblo/asociaciones', label: 'Asociaciones' },
      ],
    },
    {
      id: 2,
      label: 'Servicios',
      dropdownItems: [
        { link: '/servicios/actividades', label: 'Actividades' },
        { link: '/servicios/reserva-pistas', label: 'Reserva de Pistas' },
      ],
    },
    {
      id: 6,
      label: 'Economía Local',
      dropdownItems: [
        { link: '/economia-local/alojamientos', label: 'Alojamientos' },
        { link: '/economia-local/empresas', label: 'Empresas Locales' },
      ],
    },
    { id: 3, link: '/empleo', label: 'Empleo' },
    { id: 4, link: 'https://escalonilla.sedelectronica.es', label: 'Sede electrónica', external: true },
  ];

  const isExactActive = (path) => location.pathname === path;

  return (
    <header className="header">
      {/* Añadimos padding horizontal (px-4) para separar bordes */}
      <Container fluid className="px-4 d-flex flex-wrap justify-content-between align-items-center py-3">
        <Link to="/" className="brand d-flex align-items-center text-decoration-none mx-2">
          <img src={escudo} width="60" className="escudo me-3" alt="Escudo de Escalonilla" />
          <span className="title mobile-title-center">Ayuntamiento de Escalonilla</span>
        </Link>

        <Link to="/chat" className="chat-navbar-button mx-2">
          <FaRobot className="chat-icon me-1" /> Asistente Virtual
        </Link>
        <div className="social-icons d-flex">
          <a
            href="https://www.instagram.com/ayuntamientodeescalonilla"
            className="social-icon"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram />
          </a>
          <a
            href="https://whatsapp.com/channel/0029VasoHEs7IUYOd627A746"
            className="social-icon"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaWhatsapp />
          </a>
          <a
            href="https://plenos-escalonilla.web.app/f"
            className="social-icon"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaYoutube />
          </a>
        </div>
      </Container>

      <BootstrapNavbar expand="lg" expanded={expanded} onToggle={setExpanded} collapseOnSelect className="Navbar">
        <Container fluid>
          <BootstrapNavbar.Toggle aria-controls="basic-navbar-nav" className="border-0">
            <FaBars className="hamburger-icon" />
          </BootstrapNavbar.Toggle>
          <BootstrapNavbar.Collapse id="basic-navbar-nav">
            <Nav className="nav-links navbar-nav-custom">
              {links.map((x) =>
                x.dropdownItems ? (
                  <NavDropdown
                    key={x.id}
                    title={<span className={`nav-link-inner ${isExactActive(x.link) ? 'active' : ''}`}>{x.label.toUpperCase()}</span>}
                    id={`nav-dropdown-${x.id}`}
                    className="nav-item nav-dropdown"
                    show={
                      (x.label.toLowerCase() === 'ayuntamiento' && showAyuntamiento) ||
                      (x.label.toLowerCase() === 'el pueblo' && showPueblo) ||
                      (x.label.toLowerCase() === 'servicios' && showServicios) ||
                      (x.label.toLowerCase() === 'economía local' && showEconomia)
                    }
                    onMouseEnter={() => {
                      if (x.label.toLowerCase() === 'ayuntamiento') setShowAyuntamiento(true);
                      if (x.label.toLowerCase() === 'el pueblo') setShowPueblo(true);
                      if (x.label.toLowerCase() === 'servicios') setShowServicios(true);
                      if (x.label.toLowerCase() === 'economía local') setShowEconomia(true);
                    }}
                    onMouseLeave={() => {
                      if (x.label.toLowerCase() === 'ayuntamiento') setShowAyuntamiento(false);
                      if (x.label.toLowerCase() === 'el pueblo') setShowPueblo(false);
                      if (x.label.toLowerCase() === 'servicios') setShowServicios(false);
                      if (x.label.toLowerCase() === 'economía local') setShowEconomia(false);
                    }}
                  >
                    {x.dropdownItems.map((item, i) => (
                      <NavDropdown.Item
                        key={i}
                        as={Link}
                        to={item.link}
                        className={location.pathname === item.link ? 'active' : ''}
                        onClick={closeNavbar}
                      >
                        {item.label}
                      </NavDropdown.Item>
                    ))}
                  </NavDropdown>
                ) : x.external ? (
                  <Nav.Link 
                    key={x.id} 
                    href={x.link} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="nav-item"
                  >
                    <span className="nav-link-inner">{x.label.toUpperCase()}</span>
                  </Nav.Link>
                ) : (
                  <Nav.Link key={x.id} as={Link} to={x.link} className={`nav-item ${isExactActive(x.link) ? 'active' : ''}`} onClick={closeNavbar}>
                    <span className="nav-link-inner">{x.label.toUpperCase()}</span>
                  </Nav.Link>
                )
              )}
            </Nav>
          </BootstrapNavbar.Collapse>
        </Container>
      </BootstrapNavbar>
    </header>
  );
};

export default Navbar;